import { render } from "./infoExclamationMark.vue?vue&type=template&id=16d89ae7"
import script from "./infoExclamationMark.vue?vue&type=script&lang=js"
export * from "./infoExclamationMark.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__